import React from 'react';
import { Button, Card, Col, Form, Modal, Row, Upload } from 'antd';
import { toast } from 'react-toastify';
import InsertDriveFileIcon from '@mui/icons-material/InsertDriveFile';
import { UploadOutlined } from '@ant-design/icons';
import { ResponseDataType, postRequest } from 'api';
import { useAppContext } from 'Context/AppContext';
import styles from '../../bill.module.css';

interface InputFileBill {
  fileBill: any;
}

interface FormValueType {
  file: any;
}

export const CreateHealthInsuranceBill = () => {
  const [form] = Form.useForm();
  const { setTabNumber } = useAppContext();
  const schoolId = localStorage.getItem('schoolId') || '';

  const HandleInputFile = (value: FormValueType) => {
    Modal.confirm({
      style: { fontFamily: 'Quicksand' },
      title: 'Xác nhận import biên lai BHYT.',
      async onOk() {
        const formData = new FormData();
        formData.append('file', value.file[0].originFileObj);

        const response: ResponseDataType<InputFileBill> = await postRequest(
          `/cms/health-insurance/import?schoolId=${schoolId}`,
          formData,
          'form-data'
        );
        if (response) {
          if (response.code === 200) {
            toast.success('Import biên lai BHYT thành công!');
          } else if (response.code === -1020) {
            toast.error(response.msg || 'Có dòng dữ liệu không hợp lệ. Vui lòng kiểm tra tab Lỗi!');
            setTabNumber(2);
          } else {
            toast.error(response.msg || 'Import biên lai BHYT thất bại!');
          }
        } else {
          toast.error('Import biên lai BHYT thất bại!');
        }
      },
    });
  };

  return (
    <div>
      <Card title="Import biên lai BHYT từ Excel" className={styles.bill_info_card}>
        <Form form={form} onFinish={HandleInputFile}>
          <Row>
            <Col span={8}>
              <div className={styles.card_content_label}>
                <InsertDriveFileIcon />
                &nbsp;&nbsp;File Excel:
              </div>
            </Col>
            <Col span={16}>
              <Form.Item
                name="file"
                valuePropName="fileList"
                getValueFromEvent={(e) => (Array.isArray(e) ? e : e && e.fileList)}
                rules={[
                  { required: true, message: 'Cần chọn file!' },
                  {
                    validator: (_, value) =>
                      value && value.length > 0 && /\.(xlsx|xls)$/i.test(value[0].name)
                        ? Promise.resolve()
                        : Promise.reject(new Error('Chỉ chấp nhận file Excel (.xls, .xlsx)!')),
                  },
                ]}
              >
                <Upload beforeUpload={() => false}>
                  <Button icon={<UploadOutlined />}>Chọn file</Button>
                </Upload>
              </Form.Item>
            </Col>
          </Row>

          <Button type="primary" htmlType="submit">
            IMPORT FILE
          </Button>
        </Form>
      </Card>
    </div>
  );
};
